import { ParameterName, ParameterValue } from 'views/Parameters/types';

export type DynamicParameterLimits = {
  name: string;
  min: ParameterValue;
  max: ParameterValue;
};

const FALLBACK_LIMITS = {
  min: 0,
  max: 999,
};

export const F6_PARAMETER_LIMITS: DynamicParameterLimits[] = [
  {
    name: ParameterName.SLM_DIR_FLOW_GREEN,
    min: ParameterName.SLM_DIR_FLOW_YELLOW,
    max: 100,
  },
  {
    name: ParameterName.SLM_DIR_FLOW_YELLOW,
    min: 0,
    max: ParameterName.SLM_DIR_FLOW_GREEN,
  },
  {
    name: ParameterName.SLM_SPAC_NEED_GREEN,
    min: ParameterName.SLM_SPAC_NEED_YELLOW,
    max: 100,
  },
  {
    name: ParameterName.SLM_SPAC_NEED_YELLOW,
    min: 0,
    max: ParameterName.SLM_SPAC_NEED_GREEN,
  },
  {
    name: ParameterName.SLM_SPAC_USE_GREEN,
    min: ParameterName.SLM_SPAC_USE_YELLOW,
    max: 100,
  },
  {
    name: ParameterName.SLM_SPAC_USE_YELLOW,
    min: 0,
    max: ParameterName.SLM_SPAC_USE_GREEN,
  },
  {
    name: ParameterName.SLM_MIN_INDEL_AMOUNT,
    min: 1,
    max: 3,
  },
  {
    name: ParameterName.SLM_WARN_ASSQ_DAYS,
    min: 0,
    max: 112,
  },
  {
    name: ParameterName.SLM_WARN_UNPLAN_DAYS,
    min: 0,
    max: 28,
  },
  // Not specified in source code, so using fallback values
  {
    name: ParameterName.SLM_EXCESSIVE_DAYS,
    ...FALLBACK_LIMITS,
  },
  {
    name: ParameterName.SLM_EXCESSIVE_LIMIT,
    ...FALLBACK_LIMITS,
  },
  {
    name: ParameterName.SLM_NEW_ART_WEEKS,
    ...FALLBACK_LIMITS,
  },
  {
    name: ParameterName.SLM_SLID_START_DAYS,
    ...FALLBACK_LIMITS,
  },
  // Booleans
  {
    name: ParameterName.ALERT_LOC_LOC_SHORT,
    min: false,
    max: true,
  },
  {
    name: ParameterName.ALERT_OVER_MAX,
    min: false,
    max: true,
  },
  {
    name: ParameterName.ALERT_UNDER_MIN,
    min: false,
    max: true,
  },
  {
    name: ParameterName.ALERT_UNPLANNED_ART,
    min: false,
    max: true,
  },
  {
    name: ParameterName.SMDQ_FORECAST_PERC,
    min: 0,
    max: 100,
  },
  {
    name: ParameterName.SMDQ_MUPQ_PERC,
    min: 0,
    max: 100,
  },
  {
    name: ParameterName.SMDQ_SSC,
    min: 1,
    max: 100,
  },
];
